import { useState, useEffect, useRef } from "react";
import { debounce } from "lodash";
import ReferralSelectComponent from "../common/referral-select/ReferralSelectComponent";
import CreateHousingExpenseForm from "./CreateForm";
import CustomModal from "components/common/modal";
import { useNavigate } from "react-router-dom";
import { Members_PATH } from "constants/routePaths";
import { getMembers } from "containers/members/api";
import { initialMetaForTable } from "constants/common";
// const { DEBOUNCE_DELAY, initialMetaForTable } = require("constants/common");
// const { getMembers } = require("containers/members/api");

const DEBOUNCE_DELAY = 300;

const AddExpenseWithMember = ({
  handleOpenAddNewMemberModal,
  handleExpenseModalClose,
  selectedExpense = "",
  setSelectedExpense = () => { },
  handleRefresh = () => { },
  preSelectedMember = null,
}) => {
  const [members, setMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState(preSelectedMember);
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const result = await getMembers({
        ...initialMetaForTable,
        page: 1,
        mif_status: "all",
        history: true,
      });

      if (result?.members) {
        setMembers(result?.members);
        if (selectedExpense) {
          const findReferralInOption = members.find(
            (el) => el.id === selectedExpense.member.id,
          );
          if (!findReferralInOption) {
            setMembers([...(result?.members || []), selectedExpense.member]);
          }
          setSelectedMember(selectedExpense.member);
        }
      }
    })();
  }, []);

  const useDebouncedDataCallback = () => {
    const debouncedFetch = useRef(
      debounce(async (inputValue, callback) => {
        try {
          const response = await getMembers({
            search: inputValue,
            mif_status: "all",
            history: true,
          });
          let data = Array.isArray(response?.members) ? response.members : [];
          if (preSelectedMember) {
            let checkMember = data.filter(
              (item) => item.id === preSelectedMember.id,
            );
            if (checkMember.length === 0) {
              data = [...data, preSelectedMember];
            }
          }
          let formattedOptions = Array.isArray(data)
            ? data.map((el) => ({
              ...el,
              value: el.id,
              label:
                el.name ||
                `${el.first_name || ""} ${el.last_name || ""}`.trim(),
              cin: el.cin,
            }))
            : [];

          if (!formattedOptions || formattedOptions.length === 0) {
            callback([]); // Ensure empty array is returned
          } else {
            callback(formattedOptions);
          }
        } catch (error) {
          console.error("Failed to fetch members:", error);
          callback([]);
        }
      }, DEBOUNCE_DELAY),
    ).current;

    return debouncedFetch;
  };
  const debouncedDataCallback = useDebouncedDataCallback();

  // useEffect(() => {
  //   setMembers(memberss);
  //   if (selectedExpense) {
  //     const findReferralInOption = memberss.find(
  //       (el) => el.id === selectedExpense.member.id
  //     );
  //     if (!findReferralInOption) {
  //       setMembers([...memberss, selectedExpense.member]);
  //     }
  //     setSelectedMember(selectedExpense.member);
  //     setModalOpen(true);
  //   }
  // }, []);

  const noOptionsMessage = ({ inputValue }) => {
    if (!inputValue) return "Type to search members...";

    return (
      <div style={{ textAlign: "center", padding: "10px" }}>
        <strong>No results for "{inputValue}"</strong>
        <p>Check the spelling or try a new search</p>
        <button
          style={{
            backgroundColor: "#EAB308",
            color: "#000",
            border: "none",
            padding: "10px 20px",
            borderRadius: "8px",
            cursor: "pointer",
            marginTop: "10px",
          }}
          onClick={() => {
            handleExpenseModalClose();
            navigate(Members_PATH);
          }}
        >
          Add New Member
        </button>
      </div>
    );
  };

  const handleMemberChange = (obj) => {
    setSelectedExpense("");
    setSelectedMember(obj);
    setModalOpen(true);
  };

  return (
    <>
      <ReferralSelectComponent
        label="Member"
        options={members.map((el) => ({
          ...el,
          value: el.id,
          label:
            el.name || `${el.first_name || ""} ${el.last_name || ""}`.trim(),
          avatar: true,
          cin: el.cin,
        }))}
        dataCallback={(inputValue) =>
          new Promise((resolve) => {
            debouncedDataCallback(inputValue, (options) => {
              resolve(options || []);
            });
          })
        }
        noOptionsMessage={noOptionsMessage}
        placeholder="Select Member"
        selectedValue={
          selectedExpense ? selectedExpense.member.id : selectedMember?.id
        }
        handleChange={handleMemberChange}
        disabled={!!preSelectedMember}
      />

      {selectedMember && (
        <CreateHousingExpenseForm
          key={selectedMember.id}
          selectedMember={selectedMember}
          selectedExpense={selectedExpense}
          onClose={() => {
            handleExpenseModalClose();
            handleRefresh();
          }}
        />
      )}
    </>
  );
};

export default AddExpenseWithMember;
